export default [
  {
    path: "/department/search",
    name: "department-search",
    component: () => import("@/views/MasterDepartment/PageSearch.vue"),
    meta: {
      pageTitle: "Department",
      breadcrumb: [
        {
          text: "Department Master Search",
          active: true,
        },
      ],
    },
  },
  {
    path: "/admin/search",
    name: "admin-search",
    component: () => import("@/views/AdminManage/PageSearch.vue"),
    meta: {
      pageTitle: "Admin",
      breadcrumb: [
        {
          text: "Request Search (Admin)",
          active: true,
        },
      ],
    },
  },
  {
    path: "/request/search",
    name: "request-search",
    component: () => import("@/views/MRequest/PageSearch.vue"),
    meta: {
      pageTitle: "Request",
      breadcrumb: [
        {
          text: "Request Search",
          active: true,
        },
      ],
    },
  },
  {
    path: "/request/form",
    name: "request-form",
    component: () => import("@/views/MRequest/PageForm.vue"),
    meta: {
      pageTitle: "Request",
      breadcrumb: [
        {
          text: "Request Form",
          active: true,
        },
      ],
    },
  },
  {
    path: "/customer/search",
    name: "customer-search",
    component: () => import("@/views/MasterCustomer/PageSearch.vue"),
    meta: {
      pageTitle: "Master Customer",
      breadcrumb: [
        {
          text: "Master Customer Search",
          active: true,
        },
      ],
    },
  },
  {
    path: "/customer/form",
    name: "customer-form",
    component: () => import("@/views/MasterCustomer/PageForm.vue"),
    meta: {
      pageTitle: "Master Customer",
      breadcrumb: [
        {
          text: "Master Customer Search",
        },
        {
          text: "Master Customer Form",
          active: true,
        },
      ],
    },
  },
  {
    path: "/user/search",
    name: "user-search",
    component: () => import("@/views/MasterUser/PageSearch.vue"),
    meta: {
      pageTitle: "Master User",
      breadcrumb: [
        {
          text: "Master User Search",
          active: true,
        },
      ],
    },
  },
  {
    path: "/user/form",
    name: "user-form",
    component: () => import("@/views/MasterUser/PageForm.vue"),
    meta: {
      pageTitle: "Master User",
      breadcrumb: [
        {
          text: "Master User Search",
        },
        {
          text: "Master User Form",
          active: true,
        },
      ],
    },
  },
   {
    path: "/user/pass",
    name: "user-pass",
    component: () => import("@/views/MasterUser/PageFormPass.vue"),
    meta: {
      pageTitle: "Change Password",
      breadcrumb: [ 
        {
          text: "Change Password",
          active: true,
        },
      ],
    },
  },
  {
    path: "/template/search",
    name: "template-search",
    component: () => import("@/views/Template/PageSearch.vue"),
    meta: {
      pageTitle: "Template",
      breadcrumb: [
        {
          text: "Template Search",
          active: true,
        },
      ],
    },
  },
  {
    path: "/rider/menu",
    name: "rider-menu",
    component: () => import("@/views/Rider/PageSearch.vue"),
    meta: {
      pageTitle: "Rider Menu",
      breadcrumb: [
        {
          text: "Rider Menu",
          active: true,
        },
      ],
    },
  },
  {
    path: "/rider/report",
    name: "rider-report",
    component: () => import("@/views/Rider/PageReport.vue"),
    meta: {
      pageTitle: "Rider Performance",
      breadcrumb: [
        {
          text: "Rider Performance",
          active: true,
        },
      ],
    },
  },
  {
    path: "/rider/deptreport",
    name: "rider-deptreport",
    component: () => import("@/views/Rider/PageReportDept.vue"),
    meta: {
      pageTitle: "Department Usage",
      breadcrumb: [
        {
          text: "Department Usage",
          active: true,
        },
      ],
    },
  },
  {
    path: "/template/form",
    name: "template-form",
    component: () => import("@/views/Template/PageForm.vue"),
    meta: {
      pageTitle: "Template",
      breadcrumb: [
        {
          text: "Template Form",
          active: true,
        },
      ],
    },
  },
];
